// extracted by mini-css-extract-plugin
export default {"AdvancedConfigurationWrapper":"_2Is01CbdqaFNkpeuyT03GA==","AdvancedConfigurationTabDiv":"g9xZkM-hjUXvuFIB4+bvAA=="};